import React, { Component } from "react";

import AccountReceivableTerms from "../components/accounts/AccountReceivableTerms";
import PMDecisionsCurrentMarketingSpend from "../components/pm/decisions/PMDecisionsCurrentMarketingSpend";
import PMDecisionsRevenueForecast from "../components/pm/decisions/PMDecisionsRevenueForecast";
import PMDecisionsPromotionalSpend from "../components/pm/decisions/PMDecisionsPromotionalSpend";
import PMDecisionsPlacement from "../components/pm/decisions/PMDecisionsPlacement";
import { Loader } from "react-loaders";

import { batchRequest } from "../api/ApiService";
import Auth from "../routes/Auth";
import { submitDecisions, getSubmissionData, updateSubmissionFromJournal } from "../api/SubmitDecisions";
import SubmitDecisionsButton from "../components/ui-building-blocks/buttons/submit-decisions";
import EventEmitter from "../services/event-emitter";
import { logError, detectMobile } from "../services/utils";
import RoleButtons from "../components/role-buttons";
import Styled from "components/pm/style";
import ArrowSvg from "components/pm/arrow.svg";
import { view } from "@risingstack/react-easy-state";
import LastStepModal from '../components/get-started/last-step';
import SuccessAlert from "../components/alerts/success";
import ErrorAlert from "../components/alerts/error";

class PMDecisions extends Component {
  constructor(props) {
    super(props);

    let role = Auth.getRole();
    let has_access = role === "CEO" || role === "PM";
    // isOwnRole will be used to show or hide <RoleButtons />
    let isOwnRole = role === "PM";

    this.state = {
      marketing_clients: {},
      sales_clients: {},
      sales: [],
      promos: [],
      price_forecasts: [],
      products: [],
      accountsReceivable: 0,
      loaded: false,
      hasAccess: has_access,
      isOwnRole,
      roleAlert: false,
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      rounds: props.rounds,
      submission_data: {
        pm: {
          date: "N/A",
          unaccepted: 0
        }
      },
      submitDecisionsLoading: false,
      showNoProductsModal: false,
      isPreChecked: false,
      successMessage: null,
    };

    this.eventemitter = EventEmitter.getInstance();
    this.isMobile = detectMobile();
  }

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  hideErrorMessage = () => {
    this.setState({
      errorMessage: null,
    });
  }

  hideNoProductsModal = () => {
    this.setState({
      showNoProductsModal: false,
    });
  }

  reloadRole = () => {
    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "PM";
    const isOwnRole = role === "PM";

    this.setState({
      hasAccess,
      isOwnRole
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds &&
        this.state.rounds.length === 0 &&
        nextProps.rounds &&
        nextProps.rounds.length !== 0)
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
          this.reloadRole();
        }
      );
    }
  }

  showRoleAlert = () => {
    this.setState({
      roleAlert: true
    });
  };

  hideRoleAlert = () => {
    this.setState({
      roleAlert: false
    });
  };

  submitDecisions = () => {
    this.setState({
      submitDecisionsLoading: true
    });
    submitDecisions("marketing", this.roundNumber, this.getSubmissionData);
  };

  get roundNumber() {
    const { roundInUrl, currentRound } = this.state;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return roundInUrl;
    }

    return currentRound;
  }

  getMarketingClients() {
    let appURL = `${process.env.REACT_APP_API_URL}static/marketing_clients/`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}?team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  getSalesClients() {
    let appURL = `${process.env.REACT_APP_API_URL}static/sales_clients/`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}?team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  getSales() {
    const roundNumber = this.roundNumber;
    let appURL = `${process.env.REACT_APP_API_URL}team/sales/?round_number=${roundNumber}`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}&team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  getPromos() {
    const roundNumber = this.roundNumber;
    let appURL = `${process.env.REACT_APP_API_URL}team/promos/?round_number=${roundNumber}`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}&team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  getPriceForecasts() {
    const roundNumber = this.roundNumber;
    let appURL = `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${roundNumber}`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}&team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  getProducts() {
    const roundNumber = this.roundNumber;
    let appURL = `${process.env.REACT_APP_API_URL}team/products/?round_number=${roundNumber}`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}&team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  getPriorBalanceSheet() {
    let priorRoundNumber = this.roundNumber - 1;
    if (priorRoundNumber < 1) {
      priorRoundNumber = 1;
    }

    let appURL = `${process.env.REACT_APP_API_URL}team/report/balance_sheet/?round_number=${priorRoundNumber}`;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}&team_id=${temporaryUser.team_id}`;
    }

    return appURL;
  }

  fetchData = () => {
    const currentRound = this.roundNumber;
    const temporaryUser = Auth.getTemporaryUser();
    const joinRequest = batchRequest([
      this.getMarketingClients(),
      this.getSalesClients(),
      this.getSales(),
      this.getPromos(),
      this.getPriceForecasts(),
      this.getProducts(),
      this.getPriorBalanceSheet(),
      `${process.env.REACT_APP_API_URL}games/${Auth.getGameId()}/journal/?round_number=${currentRound}${temporaryUser ? `&team_id=${temporaryUser.team_id}` : ''}`,
    ]);

    joinRequest
      .then(res => {
        let marketing_clients = {};
        let sales_clients = {};
        let sales = res[2].body;
        let promos = res[3].body;
        let price_forecasts = res[4].body;
        let products = res[5].body;
        let balanceSheet = res[6].body;
        const journal = res[7].body;

        const pathFound1 = journal.filter(i => i.path.indexOf('/api/team/price_forecasts/') === 0).length > 0;
        const pathFound2 = journal.filter(i => i.path.indexOf('/api/team/promos/') === 0).length > 0;
        const pathFound3 = journal.filter(i => i.path.indexOf('/api/team/sales/') === 0).length > 0;
        const isPreChecked = pathFound1 || pathFound2 || pathFound3;

        const { rounds } = this.state;
        const round = rounds.find(i => i.number === currentRound);

        if (round) {
          sales = sales.filter(i => i.round === round.id);
          promos = promos.filter(i => i.round === round.id);
          price_forecasts = price_forecasts.filter(i => i.round === round.id);
          products = products.filter(i => i.round === round.id);
          balanceSheet = balanceSheet.filter(i => i.round === round.id);
        }

        const res0 = res[0].body;
        res0.forEach(item => {
          marketing_clients[item.name] = item.id;
        });

        const res1 = res[1].body;
        res1.forEach(item => {
          let { name } = item;

          if (name === "SalesRep") {
            name = "Direct Sales";
          } else if (name === "Distributor1") {
            name = "Distributors";
          }

          sales_clients[name] = item.id;
        });

        let accountsReceivable = 0;
        if (
          currentRound > 1 &&
          balanceSheet.length > 0 &&
          "Accounts Receivable" in balanceSheet[0]
        ) {
          accountsReceivable = balanceSheet[0]["Accounts Receivable"];
        }

        this.setState({
          marketing_clients,
          sales_clients,
          sales,
          promos,
          price_forecasts,
          products,
          accountsReceivable,
          loaded: true,
          isPreChecked,
        });
      })
      .catch(err => {
        logError(err, "PMDecisions", "fetchData");
      });
  };

  getSubmissionData = () => {
    this.setState({
      submitDecisionsLoading: true
    });

    const temporaryUser = Auth.getTemporaryUser();
    getSubmissionData(["pm"], temporaryUser).then(
      submission_data => {
        this.setState({
          submission_data,
          submitDecisionsLoading: false
        });
      }
    );
  };

  componentDidMount() {
    this.eventemitter.on("update-submit-decisions", this.updateSubmitDecisions);
    this.getSubmissionData();
    this.fetchData();
  }

  componentWillUnmount() {
    this.eventemitter.off("update-submit-decisions", this.updateSubmitDecisions);
    if (this.products_timer) {
      clearTimeout(this.products_timer);
      this.products_timer = null;
    }
  }

  updateSubmitDecisions = () => {
    const { roundInUrl, currentRound } = this.state;

    updateSubmissionFromJournal(
      ['pm'],
      roundInUrl !== null ? roundInUrl : currentRound,
      submission_data => {
        this.setState({
          submission_data,
        });
      }
    );
  }

  get actionsAllowed() {
    if (this.state.hasAccess === false) {
      return false;
    }

    if (this.props.roundShouldBeFinished === true) {
      return false;
    }

    const { roundInUrl } = this.state;
    const { currentRound, rounds } = this.props;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  productMarketingDecisionsTour = e => {
    e.preventDefault();
    // do nothing there
  };

  get countOfProducts() {
    return this.state.products.length;
  }

  showSetPricingModal = () => {
    const { products } = this.state;

    if (!products || products.length === 0) {
      this.setState({
        showNoProductsModal: true,
      });
    } else {
      this.eventemitter.trigger("pm-decisions-open-modal");
    }
  };

  showSetPromoBudgetModal = () => {
    this.eventemitter.trigger("pm-decisions-open-modal2");
  };

  get isSetPromoBudgetDisabled() {
    return (
      this.state.price_forecasts.filter(i => i.player !== null).length === 0
    );
  }

  showSetSalesChannelModal = () => {
    this.eventemitter.trigger("pm-decisions-open-modal3");
  };

  get isSetSalesChannelDisabled() {
    return (
      this.state.price_forecasts.filter(i => i.player !== null).length === 0
    );
  }

  showSetCreditTerms = () => {
    this.eventemitter.trigger("pm-decisions-open-modal4");
  };

  render() {
    const actionsAllowed = this.actionsAllowed;
    const {
      isOwnRole,
      accountsReceivable,
      showNoProductsModal,
      isPreChecked,
      successMessage,
    } = this.state;
    const {
      location,
      router,
      currentRound: round,
    } = this.props;

    return (
      <Styled.BodyWrapper>
        <LastStepModal
          location={location}
          router={router}
          url={`/decisions/product-marketing?round=${round}`}
        />
        <Styled.TitleWrapper>
          <Styled.Title id="product-marketing-decisions-title">
            Product Marketing
            {isOwnRole && <RoleButtons type="product_marketing" />}
          </Styled.Title>
          {actionsAllowed === true && this.state.loaded === true && (
            <SubmitDecisionsButton
              id="product-marketing-submit-decisions"
              tooltipPlacement="bottom"
              data={this.state.submission_data.pm}
              isLoading={this.state.submitDecisionsLoading}
              onClick={this.submitDecisions}
              buttonComponent={Styled.SubmitDecisionButton}
              isPreChecked={isPreChecked}
            />
          )}
        </Styled.TitleWrapper>
        {this.state.rounds && this.state.rounds.length > 0 && (
          <AccountReceivableTerms
            getSubmissionData={this.getSubmissionData}
            rounds={this.state.rounds}
            roundNumber={this.roundNumber}
            showSuccessMessage={this.showSuccessMessage}
          />
        )}
        {actionsAllowed === true && (
          <Styled.ButtonsWrapper>
            <div className="row pm-decisions-buttons">
              <Styled.ButtonsWrapperFlex className="col-md-12 col-xs-12">
                <Styled.UIButton onClick={this.showSetPricingModal}>
                  Set Pricing
                </Styled.UIButton>
                <Styled.Arrow>
                  <img src={ArrowSvg} alt="" />
                </Styled.Arrow>
                <Styled.UIButton
                  onClick={this.showSetPromoBudgetModal}
                  disabled={this.isSetPromoBudgetDisabled}
                >
                  Set Promo Budget
                </Styled.UIButton>
                <Styled.Arrow>
                  <img src={ArrowSvg} alt="" />
                </Styled.Arrow>
                <Styled.UIButton
                  onClick={this.showSetSalesChannelModal}
                  disabled={this.isSetSalesChannelDisabled}
                >
                  Set Sales Channel
                </Styled.UIButton>
                {/* <Styled.Arrow>
                  <img src={ArrowSvg} alt="" />
                </Styled.Arrow>
                <Styled.UIButton onClick={this.showSetCreditTerms}>
                  Set Credit Terms
                </Styled.UIButton> */}
              </Styled.ButtonsWrapperFlex>
            </div>
          </Styled.ButtonsWrapper>
        )}
        {this.state.roleAlert && (
          <ErrorAlert
            title="Error | Not Authorized"
            message="You are not authorized to make decisions for this role."
            onHide={this.hideRoleAlert}
          />
        )}
        {showNoProductsModal && (
          <ErrorAlert
            title="Warning"
            message="Product Development has not created a product for you to price. Please coordinate with your Head of Product (or CEO) to develop a product first."
            onHide={this.hideNoProductsModal}
          />
        )}
        {successMessage && <SuccessAlert
          message={successMessage}
        />}
        {this.state.loaded === true ? (
          <div>
            <Styled.WhiteBlock>
              <PMDecisionsCurrentMarketingSpend
                marketing_clients={this.state.marketing_clients}
                sales_clients={this.state.sales_clients}
                sales={this.state.sales}
                promos={this.state.promos}
                isMobile={this.isMobile}
                accountsReceivable={accountsReceivable}
              />
              <PMDecisionsRevenueForecast
                hasAccess={this.state.hasAccess}
                showRoleAlert={this.showRoleAlert}
                products={this.state.products}
                price_forecasts={this.state.price_forecasts}
                reloadData={this.fetchData}
                actionsAllowed={actionsAllowed}
                countOfProducts={this.countOfProducts}
                tourMode={this.props.tourMode}
                getSubmissionData={this.getSubmissionData}
                currentRound={this.props.currentRound}
                roundInUrl={this.props.roundInUrl}
                rounds={this.props.rounds}
                showSuccessMessage={this.showSuccessMessage}
              />
            </Styled.WhiteBlock>
            <Styled.WhiteBlock>
              <PMDecisionsPromotionalSpend
                marketing_clients={this.state.marketing_clients}
                price_forecasts={this.state.price_forecasts}
                products={this.state.products}
                promos={this.state.promos}
                hasAccess={this.state.hasAccess}
                showRoleAlert={this.showRoleAlert}
                reloadData={this.fetchData}
                actionsAllowed={actionsAllowed}
                countOfProducts={this.countOfProducts}
                tourMode={this.props.tourMode}
                getSubmissionData={this.getSubmissionData}
                currentRound={this.props.currentRound}
                roundInUrl={this.props.roundInUrl}
                rounds={this.props.rounds}
                accountsReceivable={accountsReceivable}
                showSuccessMessage={this.showSuccessMessage}
              />
              <PMDecisionsPlacement
                sales_clients={this.state.sales_clients}
                hasAccess={this.state.hasAccess}
                showRoleAlert={this.showRoleAlert}
                price_forecasts={this.state.price_forecasts}
                products={this.state.products}
                sales={this.state.sales}
                reloadData={this.fetchData}
                actionsAllowed={actionsAllowed}
                countOfProducts={this.countOfProducts}
                tourMode={this.props.tourMode}
                getSubmissionData={this.getSubmissionData}
                accountsReceivable={accountsReceivable}
                showSuccessMessage={this.showSuccessMessage}
              />
            </Styled.WhiteBlock>
          </div>
        ) : (
          <Loader type="ball-scale-ripple" active />
        )}
      </Styled.BodyWrapper>
    );
  }
}

export default view(PMDecisions);



// WEBPACK FOOTER //
// ./src/containers/PMDecisions.js